import React from "react";
import { useTranslation } from "react-i18next";
import TextInput from "./TextInput";
import "../styles.css";

const ContactInfo = ({ label, ...props }) => {
    const { t } = useTranslation();

    return (
        <>
        <div className="container">
            <div className="row">
                <div className="col"><TextInput label={t('fullname')} name="fullname" type="text" placeholder="Jane Doe" /></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('address')} name="address" type="text" placeholder="10 rue Sherbrooke" /></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('appartment')} name="appartment" type="text" placeholder="1B" /></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('zipcode')} name="zipcode" type="text" placeholder="H0H0H0"/></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('city')} name="city" type="text" placeholder="Montreal" /></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('phone')} name="phone" type="text" placeholder="1234567890" /></div>
            </div>
            <div className="row">
                <div className="col"><TextInput label={t('email')} name="email" type="email" placeholder="jane@email.com" /></div>
            </div>
        </div>
        </>
    );
};

export default ContactInfo;